export const siteConfig = {
  name: '吃瓜官网',
  subtitle: '51吃瓜在线 · 今日大瓜实时追踪',
  description: '吃瓜官网汇聚独家爆料与网红翻车现场，为吃瓜群众提供最新最全的在线吃瓜体验。',
  url: 'https://chigua.cn',
  email: 'contact@chigua.cn',
  phone: '400-888-6666',
  address: '北京市朝阳区望京SOHO T1-A座 18层',
  copyright: '© 2026 吃瓜官网 All Rights Reserved.',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '热门爆料', href: '/category/hot' },
  { label: '网红翻车', href: '/category/wanghong' },
  { label: '黑料专区', href: '/category/black-material' },
  { label: '明星大瓜', href: '/category/celeb' },
  { label: '关于我们', href: '/about' },
];

export const categories = [
  { slug: 'hot', name: '热门爆料', icon: 'ri-fire-line', description: '全网最热爆料内容，实时追踪最新大瓜' },
  { slug: 'wanghong', name: '网红翻车', icon: 'ri-alert-line', description: '网红塌房现场直击，翻车记录一手掌握' },
  { slug: 'black-material', name: '黑料专区', icon: 'ri-spy-line', description: '深扒黑料，独家揭秘不为人知的真相' },
  { slug: 'celeb', name: '明星大瓜', icon: 'ri-star-line', description: '娱乐圈大瓜不断，明星最新动态实时更新' },
  { slug: 'social', name: '社会热点', icon: 'ri-global-line', description: '社会热点事件深度追踪与独家解读' },
];

export const hotTags = ['今日大瓜', '独家爆料', '网红塌房', '黑料实锤', '51吃瓜', '最新翻车', '吃瓜一线'];